<template>
      <!-- // frame usado para mostrar o tutorial da tela de tarefas -->
    <v-dialog full-width v-model="dialogUpgradesIllis" v-if="dialogUpgradesIllis"  scrollable persistent :width="$vuetify.breakpoint.smAndDown ? '100%' : '60%'" v-resize="cardResize">
      <!-- :style="$vuetify.breakpoint.smAndDown ? 'width: 100%!important; height: 100%!important;' : 'width: 60%!important; height: 90%!important;'" -->
      <v-card :height="`${(windowHeight - 100)}px`">
        <v-card-title primary-title style="padding-top: 0px;padding-bottom: 0px;">
          <v-icon color="teal" large>new_releases</v-icon>
          <span :class="$vuetify.breakpoint.smAndDown ? 'headline' : 'display-1'" style="padding-left: 10px;"><strong>{{items[onboarding]['card_title'] ? items[onboarding]['card_title'] : 'Temos novidades...' }}</strong></span>
          <v-btn icon style="right: 0; position: absolute" slot="activator" fab @click="closeCard()">
            <v-icon color="black">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="dialogUpgradesIllis" style="padding-bottom: 0px;" >
            <v-window v-model="onboarding" >
              <v-window-item v-for="(item, index) in items" :key="index" >
                <!-- <v-card color="transparent" > -->
                  <v-layout align-center mb-3>
                    <v-icon color="teal">{{item.icon}}</v-icon>
                    <strong class="title" style="padding-left: 10px;">{{item.title}}</strong>
                  </v-layout>
                  <v-layout v-if="onboarding === index" align-center justify-center fill-height tag="v-card-text"  :style="`height:${(windowHeight - 280)}px`" column style="padding-top: 0px; padding-bottom: 0px;">
                      <div v-html="item.id_text" class="frame"></div>
                    <!-- </v-flex> -->
                  </v-layout>
                <!-- </v-card> -->
              </v-window-item>
            </v-window>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between" style="padding-bottom: 0px!important;padding-top: 0px!important;">
              <v-btn :disabled="onboarding === 0" round color="#1867c0" outline @click="prev">Anterior</v-btn>
              <!-- <v-btn flat @click="prev">
                <v-icon>navigate_before</v-icon>
              </v-btn> -->
              <v-item-group v-model="onboarding" class="text-xs-center" mandatory>
                <v-item v-for="(item, index) in items" :key="index" >
                  <v-btn slot-scope="{ active, toggle }" :input-value="active" icon @click="toggle">
                    <v-icon>fiber_manual_record</v-icon>
                  </v-btn>
                </v-item>
              </v-item-group>
              <v-btn color="#1867c0" v-if="onboarding != (items.length - 1)" round dark @click="next">Próximo</v-btn>
              <v-btn v-else round color="primary" dark @click="closeCard()">Sair</v-btn>
              <!-- <v-btn flat @click="next">
                <v-icon>navigate_next</v-icon>
              </v-btn> -->
            </v-card-actions>
            <!-- <span>
              <a href="https://www.youtube.com/channel/UChnglEU6grDpO2lHvrmyG0Q/playlists" target="_blank">Clique aqui</a>
              e acesse os nossos tutoriais!
            </span> -->
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeCard()">Fechar</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
    <!--<v-layout v-if="!dialog" wrap justify-center align-center>-->
</template>

<script>
  export default {
    name: 'PUpgradesIllis',
    props: [],
    data: () => ({
      onboarding: 0,
      windowHeight: 0,
      dialogUpgradesIllis: false,
      reloadPage: true,
      items: []
      // items: [{title: 'Bloco de notas', icon: 'assignment', id_text: 'https://www.youtube.com/embed/6eR47CW0HPk'}, {title: 'Kanban', icon: 'vertical_split', id_text: 'https://www.youtube.com/embed/YD5h8FAb9s4'}]
    }),
    mounted () {
      this.cardResize()
    },
    methods: {
      next () {
        this.onboarding = this.onboarding + 1 === this.items.length ? 0 : this.onboarding + 1
      },
      prev () {
        this.onboarding = this.onboarding - 1 < 0 ? this.items.length - 1 : this.onboarding - 1
      },
      cardResize () {
        this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      },
      closeCard () {
        this.$store.commit('loader/change_dialog', true)
        // Recarrega a página atual sem usar o cache
        if (this.reloadPage) {
          location.reload(true)
        } else {
          this.dialogUpgradesIllis = false
          this.$store.commit('loader/change_dialog', false)
        }
      }
    },
    computed: {
    }
  }
</script>

<style scoped>
  .frame {
    position: relative;
    height: 100%;
    width: 100%; 
  }
  /* .frame div {
    position: relative;
    height: 100%;
    width: 100%; 
  } */
  /* .frame iframe {
    position: relative;
    height: 100%;
    width: 100%; 
  } */
  /* .teste {
    min-width: 100%!important;
    min-height: 100%!important;
    max-width: 100%!important;
    max-height: 100%!important;
  } */
</style>



// WEBPACK FOOTER //
// src/components/shared/PUpgradesIllis.vue